// The original solution is here https://stackoverflow.com/a/53739792

import { WontFixType } from 'global-types';

export function flattenObject(
  ob: Record<string, WontFixType>,
): Record<string, string | number | boolean | null> {
  const toReturn = {};

  for (let i in ob) {
    if (!ob.hasOwnProperty(i)) continue;

    if (typeof ob[i] == 'object' && ob[i] !== null) {
      var flatObject = flattenObject(Object(ob[i]));
      for (let x in flatObject) {
        if (!flatObject.hasOwnProperty(x)) continue;
        // @ts-ignore
        toReturn[i + '.' + x] = flatObject[x];
      }
    } else {
      // @ts-ignore
      toReturn[i] = ob[i];
    }
  }
  return toReturn;
}
